import { render } from "./Index.vue?vue&type=template&id=9831dcde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9831dcde&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_im/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9831dcde"]])

export default __exports__